import { HashLink } from "react-router-hash-link";

function Footer(){

  return(
    <footer className="footer-wrapper bg-title footer-layout3">
      <div className="container">
        <div className="widget-area">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-6 col-lg-3">
                <div className="widget footer-widget">
                  <div className="th-widget-about">
                    <div className="about-logo"><a href="/"><img src="/assets/logos/MRN GREEN BG.jpg" alt="Mrn"/></a>
                    </div>
                    <p className="about-text">Driven by service excellence, innovation, and integrity, we partner with businesses to improve performance, reduce risk, and foster safe, compliant, and purpose-driven workplaces.</p>
                    <div className="th-social style2">
                      <a href="https://www.facebook.com/"><i className="fab fa-facebook-f"></i></a> 
                      <a href="https://www.twitter.com/"><i className="fab fa-twitter"></i></a> 
                      <a href="https://www.linkedin.com/"><i className="fab fa-linkedin-in"></i></a> 
                      <a href="https://www.whatsapp.com/"><i className="fab fa-whatsapp"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Useful Links</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li><HashLink smooth to="/#about">About Us</HashLink></li>
                      <li><a href="/services">Our Services</a></li>
                      <li><a href="/management">Management Team</a></li>
                      <li><HashLink smooth to="/#clients">Clients</HashLink></li>
                      <li><a href="/training">Training</a></li>
                      <li><a href="/contact">Contact Us</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Our Services</h3>
                  <div className="menu-all-pages-container footer-body">
                    Occupational Health & Safety Management Systems<br/>
                    Construction Health & Safety Files<br/>
                    Environmental Management Systems<br/>
                    SHEQ Training<br/><br/>
                    <a href="/services" >
                      <ul className="menu"><li>view more...</li></ul>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-auto">
                <div className="widget footer-widget">
                  <h3 className="widget_title">Contact Us</h3>
                  <div className="th-widget-about style2">
                    <h4 className="footer-info-title">Address Location</h4>
                    <p className="footer-info"><i className="fas fa-map-marker-alt"></i>Block B, Ground Floor Sweet Thorn On Beyers Office Park 61 Bosbok Rd, Randpark Ridge, Randburg</p>
                    <h4 className="footer-info-title">Contact Number</h4>
                    <p className="footer-info"><i className="fa-sharp fa-solid fa-phone"></i> <span><a className="text-inherit"
                          href="tel:+27724433009">+27 72 443 3009</a> <a className="text-inherit"
                          href="mailto:info@mrnohsc.co.za">info@mrnohsc.co.za</a></span></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-8">
                <div className="form-group newsletter-form style3" style={{ objectFit:"contain" }}>
                  <input id="sendMessage" className="form-control" type="email"  placeholder="Enter Your Email...." required="" style={{padding:"12px"}}/> 
                  <button type="submit" style={{top:"0px"}} className="newsletter-btn"><img src="/assets/img/icon/send-message-dm-svgrepo-com.svg" alt="send message"/></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap text-center">
        <p className="copyright-text">Copyright <i className="fal fa-copyright"></i> 2025 <a href="/">MRN Enterprise</a>.
          All Rights Reserved. Developed by <a href="https://www.tendaiict.com/">Tendai ICT</a></p>
      </div>
    </footer>
  );
}

export default Footer;